import bowser from 'yola-bowser';

const getLargestBlock = (blocks, { viewportHeight, scrollPosition }) => {
  if (!blocks.length) return null;

  const computedBlocks = blocks
    .map((block) => {
      let { top, bottom } = block.getBoundingClientRect();

      if (bowser.ios) {
        top -= scrollPosition;
        bottom -= scrollPosition;
      }

      const visibleTop = Math.max(top, 0);
      const visibleBottom = Math.min(bottom, viewportHeight);
      const visibleHeight = visibleBottom - visibleTop;

      if (visibleHeight <= 0) return null;

      return {
        height: visibleHeight,
        block,
      };
    })
    .filter((block) => block);
  const sortedBlocks = computedBlocks.sort((a, b) => b.height - a.height);
  const largestBlock = sortedBlocks[0].block;

  return largestBlock;
};

export default getLargestBlock;
